import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
    Box,
    Paper,
    Tabs,
    Tab
} from '@mui/material';
import {
    CloudDownload as FetchIcon,
    ForwardToInbox as InboxIcon
} from '@mui/icons-material';
import FetchEmails from './FetchEmails';
import ReceivedEmails from './ReceivedEmails';
import EmailForwardingSettings from '../components/EmailForwardingSettings';
import { emailAddressApi } from '../services/api';

/**
 * Email: forwarded emails first (the main way to get emails in), Gmail import
 * second. Until a forwarding address exists, the forwarded tab shows how to
 * set one up.
 */
function EmailHub() {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') === 'gmail' ? 'gmail' : 'forwarded';
    const [hasAddress, setHasAddress] = useState(null);

    useEffect(() => {
        emailAddressApi.get()
            .then(response => setHasAddress(!!response.data?.isActive))
            .catch(() => setHasAddress(false));
    }, []);

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Paper sx={{ width: '100%', minHeight: 'calc(100vh - 100px)' }}>
                <Tabs
                    value={activeTab}
                    onChange={(_, value) => setSearchParams(value === 'gmail' ? { tab: 'gmail' } : {}, { replace: true })}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        bgcolor: 'background.paper'
                    }}
                >
                    <Tab
                        value="forwarded"
                        icon={<InboxIcon />}
                        label="Forwarded emails"
                        iconPosition="start"
                        sx={{ minHeight: 64 }}
                    />
                    <Tab
                        value="gmail"
                        icon={<FetchIcon />}
                        label="Import from Gmail"
                        iconPosition="start"
                        sx={{ minHeight: 64 }}
                    />
                </Tabs>

                {activeTab === 'forwarded' && (
                    hasAddress === false ? (
                        <Box sx={{ p: 3 }}>
                            <EmailForwardingSettings />
                        </Box>
                    ) : (
                        <ReceivedEmails />
                    )
                )}

                {activeTab === 'gmail' && <FetchEmails />}
            </Paper>
        </Box>
    );
}

export default EmailHub;
